import stableHash from"stable-hash";export const defaultOptions={queries:{queryKeyHashFn:stableHash}};